<template>
  <div class="house">
    <div :class="{cur_pointer:adLinkUrl,banner:true}" :style="{ backgroundImage: 'url( ' + banner + ')'}" @click="themeLink(adLinkUrl)"></div>
    <div class="mian container1">
      <div class="hot">
        <div class="com_title">热销爆款</div>
        <div class="en_title"><span>HOT SALE</span></div>
        <div class="hot_header">
          <div :class="{item:true,active:hotActiveIndex===i}" v-for="(v,i) in hotList" :key="i" @click="hotActiveIndex=i">
            {{v.title}}
          </div>
        </div>
        <ul class="hot_body">
          <li class="item" v-for="(v,i) in localHotItem.themeContentList" :key="i" @click="themeContentLink(v)">
            <div class="img_box mask">
              <img v-lazy="v.adPhotoFileUrl">
            </div>
            <div class="sprice com_link" style="padding:6px 0px 0px;">
              市场参考价：
              <span class="line_th">￥{{ v.goodsMixInfo.salePrice | priceValue }}</span>
            </div>
            <div class="price" style="padding:6px 0px;">
              <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.goodsMixInfo.clientSalePrice | priceValue}}</p>
              <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
            </div>
            <p class="name com_hidden2 com_link">{{v.goodsMixInfo.mixName}}</p>
          </li>
        </ul>
      </div>

      <div class="selection">
        <div class="com_title">精选活动</div>
        <div class="en_title"><span>SELECTED ACTIVITIES</span></div>
        <div class="content">
          <div class="theme_img mask" v-for="(v,i) in dataSelection.themeImg" :key="i" @click="themeLink(dataSelection.adLinkUrl)">
            <img v-lazy="v" alt="">
          </div>
          <ul class="list">
            <li class="item mask" v-for="(v,i) in dataSelection.themeContentList" :key="i" @click="themeContentLink(v)">
              <img v-lazy="v.adPhotoFileUrl" alt="">
            </li>
          </ul>
        </div>
      </div>

      <div class="table" ref="refTable">
        <div class="com_title">精选家电</div>
        <div class="en_title"><span>SELECTED HOUSEHOLD APPLIANCES</span></div>
        <div class="table_header">
          <dl class="cate_item">
            <dt class="label">分类</dt>
            <dd class="content">
              <span :class="{active:query.categorySerNo === undefined}" @click="onClickCateItem(undefined)">不限</span>
              <span :class="{active:query.categorySerNo == v.serNo}" v-for="(v,i) in categoryList" :key="i" @click="onClickCateItem(v.serNo)">
                {{ v.name }}
              </span>
            </dd>
          </dl>
          <dl class="attr_item" v-for="(item,index) in proplist" :key="index">
            <dt class="label com_hidden">{{item.name}}</dt>
            <dd class="content">
              <span :class="{active:item.fieldList.find(v=>v.checked)?false:true}" @click="onClickpropItem(item)">不限</span>
              <span :class="{active:v.checked}" v-for="(v,i) in item.fieldList" :key="i" @click="onClickpropItem(item,v)">
                {{ v.value }}
              </span>
            </dd>
          </dl>
        </div>
        <div class="table_body">
          <router-link class="item" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank" v-for="(v,i) in goodsList" :key="i">
            <div class="img_box mask">
              <img v-lazy="v.mainPreviewImageFilePath" alt="">
            </div>
            <p class="name com_hidden com_link">{{v.mixName}}</p>
            <div class="price sprice com_link">市场参考价<span class="line_th">￥{{ v.salePrice | priceValue }}</span></div>
            <div class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.clientSalePrice | priceValue }}</div>
            <div class="cprice cur_pointer" v-else @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</div>
          </router-link>
        </div>
      </div>
      <!-- 没有商品 -->
      <div class="no_goods" v-if="!total">产品正在更新上架，敬请期待。</div>
      <el-pagination class="pagination" v-if="goodsList.length" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
  </div>
</template>

<script>
import {
  GetAdPositionId,
  GetElectricBasicInfo,
  GetElectricPageList,
} from "@/pages/page1/api/modules/home";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
export default {
  metaInfo: { title: "智能家电 - 多比商城" },
  components: {
    DialogLogin,
  },
  data() {
    return {
      banner: "",
      adLinkUrl: "",
      hotActiveIndex: 0,
      hotList: [],
      dataSelection: {
        themeImg: [],
      },
      categoryList: [],
      proplist: [],
      query: {
        categorySerNo: undefined,
        props: undefined,
      },
      total: 0,
      pageInfo: {
        pageNumber: 1,
        pageSize: 24,
        searchProperty: [],
        orderProperty: [],
      },
      goodsList: [],
    };
  },
  mounted() {
    // 广告位
    let adPositionId = this.$configId.adPositionId;
    this.getBanner(adPositionId.smartHomeAppliances);
    this.getHotSale(adPositionId.smartHomeHot);
    this.getSelection(adPositionId.smartHomeSelection);

    // 参数
    let query = this.$route.query;
    // console.log(query);
    Object.assign(this.query, query);
    this.query.props = query.props ? JSON.parse(query.props) : {};
    this.pageInfo.pageNumber = this.$route.query.page || 1;
    this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
    this.getElectricBasicInfo();
  },
  methods: {
    getElectricBasicInfo() {
      GetElectricBasicInfo(this.query).then((res) => {
        // console.log("获取基础属性", res);
        this.categoryList = res.data[0].categoryList;
        this.proplist = this.setPropItem(res.data[0].proplist);
        // 初始化选中属性
        this.proplist.forEach((item) => {
          for (let keyName in this.query.props) {
            if (keyName == item.fieldName) {
              item.fieldList.forEach((v) => {
                this.query.props[keyName].forEach((j) => {
                  if (v.value == j) {
                    v.checked = true;
                  }
                });
              });
            }
          }
        });
        this.getElectricPageList();
      });
    },
    setPropItem(arr) {
      arr.forEach((item) => {
        // 控制属性值数组
        this.$set(item, "fieldList", []);
        item.fieldValueOption.forEach((v) => {
          item.fieldList.push({
            value: v,
            checked: false,
          });
        });
      });
      return arr;
    },
    setCheckedFalse(arr) {
      arr.forEach((v) => {
        v.checked = false;
      });
      return arr;
    },
    onClickCateItem(serNo) {
      this.query.categorySerNo = serNo;
      this.query.props = undefined;
      this.reloadSearch();
    },
    onClickpropItem(item, v) {
      item.fieldList = this.setCheckedFalse(item.fieldList);
      if (v) {
        v.checked = true;
      }
      this.query.props = this.selectPropsObj;
      this.reloadSearch();
    },
    getElectricPageList() {
      let params = {
        ...this.query,
        sortType: 0,
        pageInfo: this.pageInfo,
      };
      GetElectricPageList(params)
        .then((res) => {
          // console.log("家电商品列表", res);
          this.goodsList = res.data;
          this.total = res.count;
          // 用户体验
          if (this.query.categorySerNo) {
            this.scrollInto("refTable");
          }
        })
        .catch(() => {
          this.total = 0;
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNumber = val;
      this.reloadSearch(val);
    },
    reloadSearch(page) {
      let query = {
        ...this.query,
        page: page ? page : undefined,
      };
      query.props = JSON.stringify(query.props);
      if (query.props === "{}") {
        query.props = undefined;
      }
      let newUrl = this.$router.resolve({
        path: "/houseElectrical",
        query,
      });
      window.open(newUrl.href, "_self");
    },

    // 广告位
    getBanner(id) {
      let params = {
        adPositionId: id,
        themeCount: 1,
        contentCount: 0,
        loadNoConTheme: 1, //不过滤没有内容的主题
      };
      GetAdPositionId(params).then((res) => {
        // console.log("当前页banner", res);
        try {
          this.banner = res.data[0].themeFileUrl;
          this.adLinkUrl = res.data[0].adLinkUrl;
        } catch (error) {}
      });
    },
    getHotSale(id) {
      let params = {
        adPositionId: id,
        themeCount: 6,
        contentCount: 5,
      };
      GetAdPositionId(params).then((res) => {
        // console.log("热销电器", res);
        res.data = this.setInfoObj(res.data);
        this.hotList = res.data;
      });
    },
    getSelection(id) {
      let params = {
        adPositionId: id,
        themeCount: 1,
        contentCount: 4,
      };
      GetAdPositionId(params).then((res) => {
        // console.log("精选电器", res);
        res.data = this.setInfoObj(res.data);
        if (res.data.length > 0) {
          Object.assign(this.dataSelection, res.data[0]);
          this.dataSelection.themeImg.push(res.data[0].themeFileUrl || "");
        }
      });
    },
    // 推广商品或品牌 兼容goodsMixInfo和brandInfo为null
    setInfoObj(arr) {
      arr.forEach((item) => {
        item.themeContentList.forEach((v) => {
          if (!v.goodsMixInfo) {
            v.goodsMixInfo = {};
          }
          if (!v.brandInfo) {
            v.brandInfo = {};
          }
        });
      });
      return arr;
    },
    // 主题位置跳转
    themeLink(url) {
      if (!url) {
        return false;
      }
      if (url.indexOf("http") == -1) {
        url = "http://" + url;
      }
      window.open(url, "_blank");
    },
    // 主题内容跳转
    themeContentLink(v) {
      // themeConType为2  且adLinkUrl有值
      if (v.adLinkUrl) {
        if (v.adLinkUrl.indexOf("http") == -1) {
          v.adLinkUrl = "http://" + v.adLinkUrl;
        }
        window.open(v.adLinkUrl, "_blank");
        return;
      }
      // 推广商品
      if (v.themeConType == 1) {
        let newUrl = this.$router.resolve({
          name: "goodsDetails",
          params: { mixSerNo: v.goodsMixSerNo + ".html" },
        });
        window.open(newUrl.href, "_blank");
      }
      // 推广品牌
      if (v.themeConType == 3) {
        let newUrl = this.$router.resolve({
          path: "/category",
          query: { brandSerNos: v.brandInfo.serNo },
        });
        window.open(newUrl.href, "_blank");
      }
    },
    scrollInto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView();
    },
    // 登录
    updateLogin(isLogin) {
      // console.log(isLogin);
      if (isLogin) {
        location.reload();
      }
    },
  },
  computed: {
    localHotItem() {
      let obj = {};
      let resItem = this.hotList.find((v, i) => i == this.hotActiveIndex);
      if (resItem) {
        obj = resItem;
      }
      return obj;
    },
    // 选中的属性
    selectPropsObj() {
      let obj = {};
      this.proplist.forEach((item) => {
        let haveCheckedArr = item.fieldList.filter((v) => v.checked);
        haveCheckedArr = haveCheckedArr.map((v) => v.value);
        if (haveCheckedArr.length > 0) {
          obj[item.fieldName] = haveCheckedArr;
        }
      });
      return obj;
    },
  },
};
</script>

<style lang="less" scoped>
.house {
  padding-bottom: 92px;
  background: #f1f1f1;
  color: #333333;
  .banner {
    height: 546px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .hot {
    margin-top: 56px;
    .hot_header {
      margin-top: 38px;
      display: flex;
      .item {
        width: calc((100% - 20px) / 6);
        height: 50px;
        margin-right: 4px;
        text-align: center;
        line-height: 50px;
        background: #ffffff;
        font-size: 16px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: @themeColor;
        }
      }
      .active {
        background: @themeColor;
        color: #ffffff;
        &:hover {
          color: #ffffff;
        }
      }
    }
    .hot_body {
      margin-top: 14px;
      display: flex;
      .item {
        width: calc((100% - 20px) / 5);
        height: 306px;
        padding: 10px 12px 0;
        box-sizing: border-box;
        background: #ffffff;
        margin-right: 5px;
        overflow: hidden;
        &:last-child {
          margin-right: 0;
        }
        .img_box {
          height: 210px;
        }
        .price {
          font-size: 16px;
          font-weight: bold;
          color: #f51616;
          line-height: 32px;
        }
        .name {
          line-height: 20px;
        }
      }
    }
  }
  .selection {
    margin-top: 66px;
    .content {
      display: flex;
      margin-top: 60px;
      height: 448px;
      .theme_img {
        width: 610px;
        height: 100%;
      }
      .list {
        width: calc(100% - 610px);
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 270px;
          height: 216px;
          margin-left: 20px;
          margin-top: 16px;
          &:nth-child(-n + 2) {
            margin-top: 0;
          }
        }
      }
    }
  }
  .table {
    padding-top: 62px;
    .table_header {
      margin-top: 36px;
      padding: 34px 30px 16px 0;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 1px 1px 0px rgba(4, 0, 0, 0.05);
      .attr_item,
      .cate_item {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .label {
          width: 100px;
          line-height: 24px;
          box-sizing: border-box;
          float: left;
          text-align: right;
          font-size: 12px;
          letter-spacing: 6px;
        }
        .content {
          width: calc(100% - 100px);
          box-sizing: border-box;
          margin-left: 100px;
          color: #333333;
          display: flex;
          flex-wrap: wrap;
          font-size: 12px;
          line-height: 24px;
          span {
            display: inline-block;
            margin-left: 50px;
            cursor: pointer;
            &:hover {
              color: @themeColor;
            }
          }
          .active {
            color: @themeColor;
          }
        }
      }
      .attr_item {
        margin-bottom: 4px;
      }
    }
    .table_body {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      .item {
        display: block;
        width: calc((100% - 50px) / 3);
        min-height: 312px;
        padding: 20px;
        padding-bottom: 10px;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-right: 24px;
        text-align: center;
        font-size: 12px;
        line-height: 1;
        background: #ffffff;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .img_box {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 208px;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .name {
          margin-top: 20px;
          font-weight: 500;
          color: #333333;
        }
        .price {
          margin-top: 20px;
          font-weight: bold;
          color: #ff0000;
        }
      }
    }
  }
  .no_goods {
    height: 200px;
    line-height: 200px;
    font-size: 14px;
    font-weight: 700;
    background-color: #fffdee;
    border: 1px solid #edd28b;
    text-align: center;
  }
  .pagination {
    text-align: right;
    margin-top: 60px;
  }
  .com_title {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
  }
  .en_title {
    font-size: 16px;
    line-height: 1;
    text-align: center;
    margin-top: 16px;
    span {
      display: inline-block;
      position: relative;
      &::before,
      &::after {
        content: "";
        display: block;
        width: 100px;
        height: 1px;
        background: #333333;
        position: absolute;
        left: -116px;
        right: auto;
        top: 50%;
        margin-top: 0.5px;
      }
      &::after {
        right: -116px;
        left: auto;
      }
    }
  }
  .mask {
    position: relative;
    cursor: pointer;
    line-height: 1;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>